/**
 * Configurazione tema condivisa per tutti i grafici Recharts.
 * Centralizza tooltip, assi, griglia, margini e animazioni per evitare duplicazione.
 */

export const CHART_TOOLTIP_STYLE = {
  backgroundColor: 'var(--surface)',
  border: '1px solid var(--border)',
  borderRadius: 10,
  boxShadow: 'var(--shadow-lg)',
  padding: '8px 12px',
  fontSize: 12,
  lineHeight: 1.5
}

export const CHART_MARGIN = { top: 8, right: 12, left: 0, bottom: 4 }

export const CHART_AXIS_TICK = { fontSize: 11, fill: 'var(--ink-500)' }

export const CHART_AXIS_LINE = { stroke: 'var(--border)' }

export const CHART_GRID_PROPS = { strokeDasharray: '3 3', stroke: 'var(--border)', vertical: false }

export const CHART_LEGEND_STYLE = { fontSize: 11, paddingTop: 8, lineHeight: '1.8' }

export const CHART_ANIMATION = { duration: 800, easing: 'ease-out' }

export const CHART_ANIMATION_FAST = { duration: 600, easing: 'ease-out' }

export const CHART_ANIMATION_PIE = { duration: 700, easing: 'ease-out' }

/**
 * Restituisce lo stile del punto attivo per le linee del grafico
 * @param {string} color - Colore del tratto della serie
 * @returns {{ r: number, strokeWidth: number, stroke: string, fill: string }} Configurazione del dot attivo
 */
export const CHART_ACTIVE_DOT = (color) => ({
  r: 5,
  strokeWidth: 2,
  stroke: 'var(--surface)',
  fill: color
})
